import styled from '@emotion/styled';
import Barcode from 'react-barcode';

interface Props {
    value: string;
    height?: number;
    width?: number;
}

function CustomBarcode({ value, height = 30, width }:Props) {
    return (
        <Wrapper style={{ height, width }} >
            <Barcode value={value}
                renderer='img'
                displayValue={false}
                margin={0}
                height={height} />
        </Wrapper>
    );
}

const Wrapper = styled.div`
    max-width: 100%;

    img {
        width: 100%;
        height: 100%;
    }
`;

export default CustomBarcode;
